export class Agent {
    constructor(){
        return undefined
    }
}
